import { Injectable } from '@angular/core';
import { Http, QueryHandlerFor, Wrapper } from '@skylab-angular-shared/core';
import { GusDataByTinQuery, GusDataByTinQueryHandlerBase } from '@skylab-shared/business';

@Injectable({ providedIn: 'root'})
@QueryHandlerFor(GusDataByTinQuery)
@Wrapper(GusDataByTinQueryHandlerBase)
export class GusDataByTinQueryHandler {
    public constructor(
        http: Http
    ) { }
}
